import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconUpgradeFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M6.333 12H9V9.334a7 7 0 0 1 14 0V12h2.667a1 1 0 0 1 1 1v15.334a1 1 0 0 1-1 1H6.333a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1m14-2.666V12h-8.666V9.334a4.333 4.333 0 0 1 8.666 0m-5.666 13.333v-4a1.333 1.333 0 0 1 2.666 0v4a1.333 1.333 0 1 1-2.666 0" clipRule="evenodd" /></svg>;
export default SvgIconUpgradeFilledSmall;